export default __webpack_public_path__ + "static/media/QV_Points_2.e01e2dcd.png";